"use client";

import React from "react";
import { ShieldCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const securityFeatures = ["Google Analytics Framework", "Cloudflare Edge Security", "Stripe Payment Verification"];
  return <section data-section-id="147328" id="thirdparty-cookies" className="bg-background text-foreground py-[120px] overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 relative">
          
          {/* Left Column - Content */}
          <div className="lg:col-span-6 flex flex-col justify-center lg:pr-16">
            <span className="font-mono text-sm text-muted-foreground mb-6 block uppercase tracking-widest">
              EXTERNAL PROVIDERS
            </span>
            <h2 className="font-serif font-bold text-4xl md:text-5xl lg:text-6xl tracking-tight text-foreground mb-6 leading-tight">
              Third-Party Cookies.
            </h2>
            <p className="text-lg text-muted-foreground max-w-md leading-relaxed border-y border-border/60 py-8 my-4">
              Our digital ecosystem integrates specialized external services to enhance performance and security. These providers may set cookies to process technical telemetry and user preferences.
            </p>
          </div>

          {/* Center Divider */}
          <div className="hidden lg:flex absolute left-1/2 top-0 bottom-0 -translate-x-1/2 justify-center py-8">
            <Separator orientation="vertical" className="h-full bg-border w-px" />
          </div>

          {/* Right Column - Card */}
          <div className="lg:col-span-6 lg:pl-16 flex items-center">
            <div ref={ref} className={`w-full transition-all duration-300 ease-in-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
              <Card className="bg-card text-card-foreground border border-border rounded-none shadow-2xl overflow-hidden">
                <CardContent className="p-8 sm:p-12 flex flex-col gap-8">
                  <div className="w-12 h-12 rounded-none bg-primary/10 flex items-center justify-center mb-2">
                    <ShieldCheck className="w-6 h-6 text-primary" />
                  </div>
                  
                  <div>
                    <h3 className="text-2xl font-serif font-semibold tracking-tight mb-4 text-foreground">
                      Provider Frameworks
                    </h3>
                    <p className="text-muted-foreground leading-relaxed text-base">
                      We partner with verified industry leaders for analytics, content delivery, and security. Review their individual privacy frameworks to understand how your data is managed across the global network.
                    </p>
                  </div>

                  <ul className="space-y-6 mt-4 pt-6 border-t border-border">
                    {securityFeatures.map((item, i) => <li key={i} data-index={i} className="flex items-center gap-4 text-sm text-foreground font-mono font-medium border-b border-primary/40 pb-2 w-fit">
                        <div className="w-1.5 h-1.5 rounded-full bg-primary shrink-0" />
                        {item}
                      </li>)}
                  </ul>
                </CardContent>
              </Card>
            </div>
          </div>

        </div>
      </div>
    </section>;
}